import { useState } from "react";
import { ConfirmationModal } from "../../../main/components/ConfirmationModal";

import { ActionAlert } from "../../../main/components/alerts/ActionAlert";
import { Item } from "./UserItemsTable";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Stack,
} from "@mui/material";

import { DialogHeader } from "../../../auth/components/PasswordRecoveryModal";
import AddUserItemTable from "./AddUserItemTable";

export function AddItemModals(props: {
  showAddItemModal: boolean;
  setShowAddItemModal: (value: boolean) => void;
  items: Item[];
  itemText: string;
  itemName: string;
  itemNamePlural?: string;
  onConfirmAddItem: (item: Item) => Promise<void>;
  onMount: () => void;
  extraButton?: JSX.Element;
  showApiErrorMessage?: boolean;
}) {
  const {
    showAddItemModal,
    setShowAddItemModal,
    itemText,
    itemName,
    itemNamePlural,
    items,
    onConfirmAddItem,
    onMount,
    showApiErrorMessage
  } = props;
  const [showAddItemConfirmationModal, setShowAddItemConfirmationModal] =
    useState<boolean>(false);
  const onClose = () => setShowAddItemModal(false);
  const [showAddItemSuccesModal, setShowAddItemSuccessModal] =
    useState<boolean>(false);
  const [showAddItemErrorModal, setShowAddItemErrorModal] =
    useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<Item | null>(null);
  const onConfirm = async () => {
    if (selectedItem) {
      await onConfirmAddItem(selectedItem);
    }
  };
  const onAdd = (item: Item) => {
    setSelectedItem(item);
    setShowAddItemConfirmationModal(true);
  };

  const [apiErrorMessage, setApiErrorMessage] = useState<string | undefined>(undefined);
  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showAddItemModal}
        maxWidth="xs"
        fullWidth
      >
        <DialogHeader id="customized-dialog-title" onClose={onClose}>
          {`Adicionar ${itemName} `}
        </DialogHeader>
        <DialogContent
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          dividers
        >
          <Stack marginTop="0px">
            <AddUserItemTable
              userItems={items}
              itemLabel={itemName}
              onAdd={onAdd}
              itemLabelPlural={itemNamePlural}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          {props.extraButton}
          <Button color="secondary" onClick={onClose}>
            {"Cancelar"}
          </Button>
        </DialogActions>
      </Dialog>
      <ConfirmationModal
        contentText={`Deseja realmente adicionar ${selectedItem?.name}?`}
        open={showAddItemConfirmationModal}
        onConfirm={onConfirm}
        setOpen={setShowAddItemConfirmationModal}
        title={`Adicionar ${itemText}`}
        setOpenErrorModal={setShowAddItemErrorModal}
        setOpenSuccessModal={setShowAddItemSuccessModal}
        setApiErrorMessage={setApiErrorMessage}
      />
      <ActionAlert
        message={`Adição d${itemText} realizada com sucesso`}
        severity="success"
        open={showAddItemSuccesModal}
        setOpen={setShowAddItemSuccessModal}
        onClose={() => {
          setShowAddItemModal(false);
          onMount();
        }}
      />
      <ActionAlert
        message={showApiErrorMessage && apiErrorMessage ? apiErrorMessage : `Ocorreu um erro ao adicionar ${itemText} ao usuário`}
        severity="error"
        open={showAddItemErrorModal}
        setOpen={setShowAddItemErrorModal}
        onClose={() => {
          setShowAddItemModal(false);
        }}
      />
    </>
  );
}
